'use client';

import { Toaster as StyledToaster } from 'sonner';
import Iconify from '@/src/components/iconify';
import IconCode from '@/src/lib/iconCode';

// ----------------------------------------------------------------------

export function Snackbar() {
    return (
        <StyledToaster
            expand
            gap={0}
            closeButton
            offset={16}
            visibleToasts={4}
            position="top-right"
            className=""
            toastOptions={{
                unstyled: true,
                classNames: {
                    // base toast box
                    toast: "relative flex items-center min-h-[52px] rounded-[12px] gap-3 w-[300px]",
                    // content
                    content: "flex-1 pr-8",
                    title: "text-sm",
                    description: "text-xs opacity-[0.64]",
                    // buttons
                    actionButton: "",
                    cancelButton: "",
                    closeButton:
                        "absolute top-0 -right-4 !left-auto z-10 text-current bg-white w-6 h-6 grid place-items-center rounded-full border border-[rgba(158,158,158,0.16)] hover:border-[rgba(158,158,158,0.24)] hover:bg-[rgba(158,158,158,0.08)] transition-colors",
                    // base icon wrapper (fixed size to prevent overlap)
                    // use inline-flex so width/height apply even if wrapper is a span
                    icon: "m-0 w-12 h-12 inline-flex shrink-0",
                    // variants
                    default:
                        "py-2 pr-2 pl-3 shadow-[0_8px_16px_rgba(0,0,0,0.12)] text-[#212121] bg-white",
                    info: "py-2 pr-2 pl-3 shadow-[0_8px_16px_rgba(0,0,0,0.12)] text-[#212121] bg-white",
                    error: "py-2 pr-2 pl-3 shadow-[0_8px_16px_rgba(0,0,0,0.12)] text-[#212121] bg-white",
                    success:
                        "py-2 pr-2 pl-3 shadow-[0_8px_16px_rgba(0,0,0,0.12)] text-[#212121] bg-white",
                    warning:
                        "py-2 pr-2 pl-3 shadow-[0_8px_16px_rgba(0,0,0,0.12)] text-[#212121] bg-white",
                },
            }}
            icons={{
                loading: (
                    <span className="w-full h-full grid place-items-center">
                        <span className="w-6 h-6 rounded-full animate-[spin_3s_linear_infinite] bg-[conic-gradient(rgba(0,0,0,0),rgba(128,128,128,0.64))]" />
                    </span>
                ),
                info: (
                    <span className="w-full h-full flex items-center justify-center rounded-[12px] text-[#0288d1] bg-[rgba(2,136,209,0.08)]">
                        <Iconify
                            className="w-6 h-6"
                            icon={IconCode.infoCircle}
                        />
                    </span>
                ),
                success: (
                    <span className="w-full h-full flex items-center justify-center rounded-[12px] text-[#2e7d32] bg-[rgba(46,125,50,0.08)]">
                        <Iconify
                            className="w-6 h-6"
                            icon={IconCode.checkCircle}
                        />
                    </span>
                ),
                warning: (
                    <span className="w-full h-full flex items-center justify-center rounded-[12px] text-[#ed6c02] bg-[rgba(237,108,2,0.08)]">
                        <Iconify
                            className="w-6 h-6"
                            icon={IconCode.dangerTriangle}
                        />
                    </span>
                ),
                error: (
                    <span className="w-full h-full flex items-center justify-center rounded-[12px] text-[#c50000] bg-[rgba(197,0,0,0.08)]">
                        <Iconify className="w-6 h-6" icon={IconCode.danger} />
                    </span>
                ),
            }}
        />
    );
}


